import { Skeleton } from '@etg/wings';
import { css } from '@eti/styles';

const withLabelSkeletonStyles = css`
  height: 48px;
  width: 144px;
`;

const MyBookingsSkeleton = () => (
  <Skeleton className={withLabelSkeletonStyles} data-testid="my-bookings-skeleton" />
);

export default MyBookingsSkeleton;
